import React, { useContext, useReducer, useState } from "react";
import { AiOutlineArrowRight, AiOutlineMail } from "react-icons/ai";
import InvalidInputModal from "../Modals/InvalidInputModal";
import { footerReducer } from "./FooterReducer";
import {
  AiOutlineInstagram,
  AiOutlineFacebook,
  AiOutlineYoutube,
  AiOutlineApple,
} from "react-icons/ai";
import { FiTwitter } from "react-icons/fi";
import { SlSocialSpotify } from "react-icons/sl";

const FooterContext = React.createContext();

const initialState = {
  user: { email: "" },
  showModal: false,
  message: "",
};

const Footer = () => {
  const [state, dispatch] = useReducer(footerReducer, initialState);
  return (
    <FooterContext.Provider value={{ state, dispatch }}>
      <Desktop />
      <Tablet />
      <Mobile />
    </FooterContext.Provider>
  );
};

const Desktop = () => {
  return (
    <div className="hidden xl:flex flex-col justify-center items-center py-30">
      <p className="text-8xl w-1/2 text-center">
        Get in touch with us.
      </p>
      <SubscriptionForm />
    </div>
  );
};

const Tablet = () => {
  return (
    <div className="hidden md:flex xl:hidden flex-col justify-center items-center py-30">
      <p className="text-5xl w-1/2 text-center">
        Get in touch with us.
      </p>
      <SubscriptionForm />
    </div>
  );
};

const Mobile = () => {
  return (
    <div className="md:hidden flex-col justify-center items-center py-30">
      <p className="text-3xl text-center">Get in touch with us.</p>
      <SubscriptionForm />
    </div>
  );
};

const SubscriptionForm = () => {
  const [user, setUser] = useState({ email: "" });
  const { state, dispatch } = useContext(FooterContext);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser(() => {
      return { ...user, [name]: value };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.email) {
      dispatch({ type: "SEND_MAIL", payload: user });
      setUser(() => {
        return { ...user, email: "" };
      });
    } else {
      dispatch({ type: "EMPTY_INPUT" });
    }
  };

  const closeModal = () => {
    dispatch({ type: "CLOSE_MODAL" });
  };

  return (
    <div>
      <DesktopIcons/>
      <TabletIcons/>
      <MobileIcons/>
      {/* <DesktopForm
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        email={user.email}
        state={state}
        closeModal={closeModal}
      />
      <TabletForm
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        email={user.email}
        state={state}
        closeModal={closeModal}
      />
      <MobileForm
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        email={user.email}
        state={state}
        closeModal={closeModal}
      /> */}
    </div>
  );
};

const DesktopForm = ({
  handleSubmit,
  handleChange,
  email,
  state,
  closeModal,
}) => {
  return (
    <div className="py-28 hidden xl:flex flex-col justify-center items-center relative">
      {state.showModal && (
        <InvalidInputModal message={state.message} closeModal={closeModal} />
      )}
      <p className="text-3xl">ENTER EMAIL ADDRESS</p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="border-black border-b-2">
          <input
            className="py-8"
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => handleChange(e)}
          />
          <button type="submit">
            <AiOutlineArrowRight />
          </button>
        </div>
      </form>
    </div>
  );
};

const TabletForm = ({
  handleSubmit,
  handleChange,
  email,
  state,
  closeModal,
}) => {
  return (
    <div className="py-14 hidden xl:hidden md:flex flex-col justify-center items-center">
      {state.showModal && (
        <InvalidInputModal message={state.message} closeModal={closeModal} />
      )}
      <p className="text-2xl">ENTER EMAIL ADDRESS</p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="border-black border-b-2">
          <input
            className="py-4"
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => handleChange(e)}
          />
          <button type="submit">
            <AiOutlineArrowRight />
          </button>
        </div>
      </form>
    </div>
  );
};

const MobileForm = ({
  handleSubmit,
  handleChange,
  email,
  state,
  closeModal,
}) => {
  return (
    <div className="py-8 md:hidden flex flex-col justify-center items-center">
      {state.showModal && (
        <InvalidInputModal message={state.message} closeModal={closeModal} />
      )}
      <p className="text-1xl">ENTER EMAIL ADDRESS</p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="border-black border-b-2">
          <input
            className="py-2"
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => handleChange(e)}
          />
          <button type="submit">
            <AiOutlineArrowRight />
          </button>
        </div>
      </form>
    </div>
  );
};

const DesktopIcons = () => {
  return (
    <div className="hidden lg:flex justify-around items-center w-full">
              <a
                href="https://www.instagram.com/popnationent?igsh=ZWtlaTIwdWFkazl1&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-8 py-8"
              >
                <AiOutlineInstagram size={40} />
              </a>
              <a
                href="https://www.facebook.com/share/16dXzGZ3Co/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-8 py-8"
              >
                <AiOutlineFacebook size={40} />
              </a>
              <a
                href="https://x.com/popnation_ke?s=21"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-8 py-8"
              >
                <FiTwitter size={40} />
              </a>
              <a
                href="https://youtube.com/@popnationentertainmentke?si=dCjMYr7G2iHEAq59"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-8 py-8"
              >
                <AiOutlineYoutube size={40} />
              </a>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=popnationentertainment@gmail.com&su=Booking%20Inquiry&body=Hello%20PopNation%20Entertainment,"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-8 py-8"
              >
                <AiOutlineMail size={40} />
              </a>
            </div>
  )
}

  const TabletIcons = () => {
    return (
      <div className="hidden md:flex lg:hidden justify-around items-center w-full">
                <a
                  href="https://www.instagram.com/popnationent?igsh=ZWtlaTIwdWFkazl1&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-4 py-4"
                >
                  <AiOutlineInstagram size={30} />
                </a>
                <a
                  href="https://www.facebook.com/share/16dXzGZ3Co/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-4 py-4"
                >
                  <AiOutlineFacebook size={30} />
                </a>
                <a
                  href="https://x.com/popnation_ke?s=21"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-4 py-4"
                >
                  <FiTwitter size={30} />
                </a>
                <a
                  href="https://youtube.com/@popnationentertainmentke?si=dCjMYr7G2iHEAq59"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-4 py-4"
                >
                  <AiOutlineYoutube size={30} />
                </a>
                <a
                  href="mailto:popnationentertainment@gmail.com?subject=Booking%20Inquiry&body=Hello%20PopNation%20Entertainment,"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-4 py-4"
                >
                  <AiOutlineMail size={30} />
                </a>
              </div>
              
    )
  }

  const MobileIcons = () => {
    return (
      <div className="flex md:hidden justify-around items-center w-full md:hidden lg:hidden">
                <a
                  href="https://www.instagram.com/popnationent?igsh=ZWtlaTIwdWFkazl1&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-2 py-2"
                >
                  <AiOutlineInstagram size={20} />
                </a>
                <a
                  href="https://www.facebook.com/share/16dXzGZ3Co/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-2 py-2"
                >
                  <AiOutlineFacebook size={20} />
                </a>
                <a
                  href="https://x.com/popnation_ke?s=21"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-2 py-2"
                >
                  <FiTwitter size={20} />
                </a>
                <a
                  href="https://youtube.com/@popnationentertainmentke?si=dCjMYr7G2iHEAq59"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-2 py-2"
                >
                  <AiOutlineYoutube size={20} />
                </a>
                <a
                  href="mailto:popnationentertainment@gmail.com?subject=Booking%20Inquiry&body=Hello%20PopNation%20Entertainment,"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:bg-black w-full h-full flex justify-center items-center hover:text-white px-2 py-2"
                >
                  <AiOutlineMail size={20} />
                </a>
              </div>
    )
  }

export default Footer;
